<template>
  <div class="c-social-links">
    <a href="https://www.facebook.com/Tuangodeals"
      ><i class="fab fa-facebook-f"></i
    ></a>
    <a href="https://twitter.com/tuango"><i class="fab fa-twitter"></i></a>
    <a href="https://www.pinterest.ca/tuango/"
      ><i class="fab fa-pinterest"></i
    ></a>
    <a href="https://www.instagram.com/tuango/"
      ><i class="fab fa-instagram"></i
    ></a>
  </div>
</template>

<script>
export default {
  name: "SocialLinks"
}
</script>
